import { type BaseQueryMeta } from '@adv-frontend/modules-query';
import { getFilenameFromHeader } from './getFilenameFromHeader';

export type DownloadableBlob = {
    blobData: Blob;
    filename: string;
};

export const mapBlobResponse = (blobData: Blob, meta: BaseQueryMeta, fallbackFilename: string): DownloadableBlob => {
    return {
        blobData,
        // Название файла приходит из данных в соответствующем заголовке
        filename: getFilenameFromHeader(meta, fallbackFilename),
    };
};
